import {
	faBrain,
	faCalendar,
	faLocationArrow,
	faLocationCrosshairs,
	faMapLocation,
	faPhone,
	faSchool,
	faSuitcase,
	faUser,
	faVenusMars,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import Badge from "../DesignSystem/Badge/Badge";
import Button from "../DesignSystem/Button/Button";
import { USER_STATUS } from "../../utils/constants";
import { useIntl } from "react-intl";
import "./Registrations.scss";
import { getKnowledgeStatusByNumber } from "./RegistrationUtils";

const UserDetailsPopup = ({
	regNumber,
	photo,
	firstName,
	lastName,
	fathersName,
	mobileNumber,
	gender,
	dob,
	formattedDob,
	approvalStatus,
	city,
	state,
	region,
	address,
	pinCode,
	education,
	occupation,
	medicalConditions,
	knowledgeStatus,
	onClose,
}) => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();

	const getBadgeTypeByStatus = () => {
		let kind = "";

		if (approvalStatus === USER_STATUS.APPROVED) {
			kind = "badge-success";
		} else if (approvalStatus === USER_STATUS.REJECTED) {
			kind = "badge-danger";
		} else {
			kind = "badge-yellow";
		}

		return kind;
	};

	return (
		<div className="user-details flex direction-col align-items-start">
			<div className="text text-body--5 text-left text-disabled">{regNumber}</div>
			<div className="flex direction-row align-items-center">
				<img src={photo} alt="user-avatar" />
				<div className="text text-header--7 text-left ml-8">{`${firstName} ${lastName}`}</div>
				<Badge className="ml-8" label={approvalStatus} kind={getBadgeTypeByStatus()} />
			</div>

			<div className="row mt-16">
				<div className="text text-body--3 text-bold text-left mb-8 popup-section-title">
					{formatMessage({ id: "registration.section.personalDetails" })}
				</div>
				<div className="row">
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faUser} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.fathername" })}
							</div>
						</div>
						<div className="text text-body--3">{fathersName}</div>
					</div>
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faPhone} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.phoneNumber" })}
							</div>
						</div>
						<div className="text text-body--3">{mobileNumber}</div>
					</div>
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faCalendar} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.dob" })}
							</div>
						</div>
						<div className="text text-body--3">{formattedDob}</div>
					</div>
				</div>
				<div className="row mt-16">
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faVenusMars} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.gender" })}
							</div>
						</div>
						<div className="text text-body--3">{gender}</div>
					</div>
				</div>
			</div>

			<div className="divider mt-16 mb-16"></div>

			<div className="row">
				<div className="text text-body--3 text-bold text-left mb-8 popup-section-title">
					{formatMessage({ id: "registration.section.additionalDetails" })}
				</div>
				<div className="row">
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faMapLocation} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.anchal" })}
							</div>
						</div>
						<div className="text text-body--3">{region}</div>
					</div>
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faLocationArrow} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.city" })}
							</div>
						</div>
						<div className="text text-body--3">{city}</div>
					</div>
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faLocationArrow} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.state" })}
							</div>
						</div>
						<div className="text text-body--3">{state}</div>
					</div>
				</div>
				<div className="row mt-16">
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faLocationCrosshairs} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.address" })}
							</div>
						</div>
						<div className="text text-body--3">{address}</div>
					</div>
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faMapLocation} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.pincode" })}
							</div>
						</div>
						<div className="text text-body--3">{pinCode}</div>
					</div>
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faSchool} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.education" })}
							</div>
						</div>
						<div className="text text-body--3">{education}</div>
					</div>
				</div>

				<div className="row mt-16">
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faSuitcase} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.occupation" })}
							</div>
						</div>
						<div className="text text-body--3">{occupation}</div>
					</div>
					<div className="col-lg-4 col-md-12 col-sm-12">
						<div className="flex direction-row align-items-center justify-content-center">
							<FontAwesomeIcon icon={faBrain} />
							<div className="text text-body--3 text-bold ml-8">
								{formatMessage({ id: "registration.knowledge" })}
							</div>
						</div>
						<div className="text text-body--3">
							{getKnowledgeStatusByNumber(knowledgeStatus, formatMessage).join(", ")}
						</div>
					</div>
				</div>
			</div>

			<div className="divider mt-16 mb-16"></div>

			<div className="row">
				<div className="text text-body--3 text-bold text-left mb-8 popup-section-title">
					{formatMessage({ id: "registration.section.medicalConditions" })}
				</div>
				<div className="col-lg-12">
					<div className="text text-body--3 text-left">{medicalConditions}</div>
				</div>
			</div>

			<div className="flex direction-row align-items-center justify-content-end mt-16">
				<Button className="button-tertiary" label="registration.actions.close" onClick={onClose} />
				{approvalStatus === USER_STATUS.PENDING ? (
					<>
						<Button
							className="button-primary button-danger ml-8"
							label="registration.actions.reject"
							onClick={onClose}
						/>
						<Button
							className="button-primary button-success ml-8"
							label="registration.actions.approve"
							onClick={onClose}
						/>
					</>
				) : (
					<></>
				)}
			</div>
		</div>
	);
};

export default connect((state) => ({}), {})(UserDetailsPopup);
